"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_ace_1 = require("react-ace");
var CardEditorContainer_1 = require("../../../../../../../shared/components/containers/CardEditorContainer");
var CardRowButtonSet_1 = require("../../../../../../../shared/components/editors/CardRowButtonSet");
var BonusTPLLocaleViewRendered = /** @class */ (function (_super) {
    __extends(BonusTPLLocaleViewRendered, _super);
    function BonusTPLLocaleViewRendered(props) {
        return _super.call(this, props) || this;
    }
    BonusTPLLocaleViewRendered.prototype.componentWillMount = function () {
        this.setState({
            textRaw: this.props.record.bonus_template_json_test_data,
            is_window_maximized: false
        });
        this.props.state.setExtBreadCrumbPath([
            "Локализации шаблона бонуса",
            "\u041F\u0440\u043E\u0441\u043C\u043E\u0442\u0440 \u0442\u0435\u0441\u0442\u043E\u0432\u044B\u0445 \u0434\u0430\u043D\u043D\u044B\u0445: [" + this.props.record.bonus_template_title + "]"
        ]);
    };
    BonusTPLLocaleViewRendered.prototype.OnGoBackClick = function () {
        if (this.props.onGoBack) {
            this.props.onGoBack();
        }
    };
    BonusTPLLocaleViewRendered.prototype.OnMaxButtonClick = function (isMax) {
        this.setState({ is_window_maximized: isMax });
    };
    BonusTPLLocaleViewRendered.prototype.getFormTitle = function () {
        return "Тестовые данные";
    };
    BonusTPLLocaleViewRendered.prototype.onChange = function (newValue) {
        this.setState({ textRaw: newValue });
    };
    BonusTPLLocaleViewRendered.prototype.getEditorHeight = function () {
        if (this.state.is_window_maximized) {
            return "calc( 100vh - 270px )";
        }
        else {
            return "450px";
        }
    };
    BonusTPLLocaleViewRendered.prototype.render = function () {
        return (React.createElement(CardEditorContainer_1.default, { onGoBackClick: this.OnGoBackClick.bind(this), onMaxButtonClick: this.OnMaxButtonClick.bind(this), title: this.getFormTitle(), state: this.props.state, maxHeight: 600, showMaxButton: true },
            React.createElement("div", { style: {
                    minHeight: "500px",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "flex-start"
                } },
                React.createElement(react_ace_1.default, { mode: "json", theme: "sqlserver", onChange: this.onChange.bind(this), name: "UNIQUE_ID_OF_RECORD_CONTENT_DIV_TPL_TEST", editorProps: { $blockScrolling: true }, width: "100%", height: this.getEditorHeight(), fontSize: 14, wrapEnabled: true, showPrintMargin: false, value: this.state.textRaw, style: { borderStyle: "solid", borderWidth: "1px", borderColor: "#d9d9d9" } }),
                React.createElement(CardRowButtonSet_1.default, { editMode: this.props.record != null, title: {
                        btnGoBack: "Вернуться"
                    }, onGoBackClick: this.OnGoBackClick.bind(this) }))));
    };
    return BonusTPLLocaleViewRendered;
}(React.Component));
exports.default = BonusTPLLocaleViewRendered;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/gift_bonus_templates/ui/component/locales/LocaleTPLViewRendered.tsx
// module id = 1909
// module chunks = 0